import { Mp4Box } from "./Mp4Box.class";

export class udta extends Mp4Box {}
